@if (initialized) {
  <div class="container">
    @if (!jobCodes.length) {
      <div class="mat-body-strong">
        No data found
      </div>
    }
    <div class="columns">
      <div>
        <div class="mat-subtitle-1">Org jobcodes</div>
        @for (jobCode of jobCodes; track jobCode) {
          <div>
            <mat-checkbox [checked]="jobCode.checked" (change)="onCheckToggle(jobCode, $event.checked)">
              <div class="mat-body-strong">
                {{jobCode.name}}
                @if (!jobCode.is_master) {
                  <span class="mat-caption">(user added)</span>
                }
              </div>
            </mat-checkbox>
          </div>
        }
      </div>
      <div>
        <div class="mat-subtitle-1">Project jobcodes</div>
        @for (jobCode of projectJobCodes; track jobCode) {
          <div class="mat-body-strong">
            {{jobCode.name}}
            @if (!jobCode.is_master) {
              <span class="mat-caption">(user added)</span>
            }
          </div>
        }
      </div>
    </div>
  </div>
}